// extracted by mini-css-extract-plugin
export default {"left-nav-container":"AppBarComponent-module__left-nav-container__7RW6U"};